import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { SourceArchivialFilter, SourceArchivialFilterMeta } from '@src/app/core/models';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-source-archivial-filters',
  styleUrls: ['./source-archivial-filters.component.scss'],
  templateUrl: './source-archivial-filters.component.html',
})
export class SourceArchivialFiltersComponent
  extends BaseFiltersComponent<SourceArchivialFilter, FilterFieldsOptions<SourceArchivialFilter>> {

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, SourceArchivialFilterMeta);
  }

}
